module.exports = __webpack_public_path__ + "static/lasciatiispirare200-7c80b14448c705f57740cb8549b37dd3.png";